import { render } from "./LogoutConfirmationPage.vue?vue&type=template&id=dcb579d4&scoped=true"
import script from "./LogoutConfirmationPage.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmationPage.vue?vue&type=script&lang=js"

import "./LogoutConfirmationPage.vue?vue&type=style&index=0&id=dcb579d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb579d4"]])

export default __exports__